import { configureStore, combineReducers } from '@reduxjs/toolkit'

//reducers
import sesion from './slices/sesion';
import ingresaTNE from './slices/ingresaTNE';

const store = configureStore({
    reducer:{
        sesion,

        ingresaTNE
    }
})


export default store